export function getFormattedTaskOrderNumber(item: string) {
  return item.toString().replace(".", "-");
}
